/**
* @name: right-layout-div
* @author: weiyong
* @date: 2023-05-11 18:02
* @description：right-layout-div
* @update: 2023-05-11 18:02
*/
<template>
  <div :class="[prefixCls,showTabs?'hasTabs':'noTabs']" class="main-panel-content h100b flex-div" >
    <LayoutContent :singlePageFlag="singlePageFlag"  :pageTitleFlag="pageTitleFlag" class="LayoutContent" />
    <!-- 绿色环保主题不展示最右侧快捷菜单/编辑区 -->
  </div>
</template>

<script lang="ts">
import {defineComponent} from 'vue';

export default defineComponent({
  components: {},
  name: "right-layout-div",
});
</script>

<script lang="ts" setup>
import {useDesign} from "@/hooks/web/useDesign";
import LayoutContent from '@/layouts/default/content/index.vue';

const {prefixCls} = useDesign('environmental-right-layout-div');

const props=defineProps({
  pageTitleFlag:{},
  systemFlag:{},
  showTabs:{},
  singlePageFlag:{},
})

</script>

<style type="text/css" lang="less">
@prefix-cls: ~'@{namespace}-environmental-right-layout-div';

.@{prefix-cls} {

  &.main-panel-content{
    &.hasTabs{
      height:calc(100% - 48px)  !important;
    }
    .LayoutContent{
      width:100%;
    }
  }
  .LayoutContent{
    height:100%  !important;
    overflow: hidden !important;
  }
}
</style>
